export const and =
  <U>(...fns: ((v: U) => boolean)[]) =>
  (v: U) =>
    fns.every(fn => fn(v));

export const not =
  <U>(fn: (v: U) => boolean) =>
  (v: U) =>
    !fn(v);

export const or =
  <U>(...fns: ((v: U) => boolean)[]) =>
  (v: U) =>
    fns.some(fn => fn(v));

export function generate<U extends unknown[], Inferences>(schema: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [Property in keyof Inferences]: (...arg: U) => any;
}) {
  return function tester(...value: U) {
    // @ts-expect-error loose typing
    const ret: Inferences = {};
    for (const k in schema) {
      const fn = schema[k];
      ret[k] = fn(...value);
    }
    return ret;
  };
}
